module.exports = {
	"application_form.entripName": "Тадбиркорлик субъекти номи",
	"application_form.invalid_type_id": "Инвалидность",
	"application_form.formError": "Хизматдан фойдаланиб бўлмади. Кейинроқ уриниб кўринг.",
	"application_form.phoneError": "Телефон рақамини тўғри киритинг.",
	"application_form.phoneLabel": "Телефон (+998xxxxxxxxx)",
	"application_form.agreementHint": "Фойдаланиш <a href={link} id={id} data-toggle={dataToggle} data-target={dataTarget}>қоидалари</a> билан танишдим",
	"application_form.answerOnlyElectron": "Мурожаатга фақат электрон шаклда жавоб берилишига розиман",
	"application_form.answerElectronAndWritten": "Мурожаатга Қоғоз ва электрон шаклда жавоб берилишига розиман",
	"application_form.yearError": "Тўғилган йилингизни тўғри форматда киритинг: (dd.mm.19xx/20xx)",
	"application_form.emailError": "Тўғри электрон почта манзилини кўрсатинг",
	"application_form.surname": "Фамилия",
	"application_form.name": "Исм",
	"application_form.secondName": "Отасининг исми",
	"application_form.fileError": "5 мбдан катта файл юклаш мумкин эмас!",
	"application_form.fileError2": "Бундай форматдаги файлни юклаш мумкин эмас!",
	"application_form.captchaError": "Жавоб нотўғри. Бошқаттан уриниб кўринг.",
	"application_form.captchaHint": "Расмдаги рақамларни киритинг",
	"application_form.region": "Ҳудуд",
	"application_form.district": "Туман (шаҳар)",
	"application_form.country": "Давлат",
	"application_form.gender": "Жинс",
	"application_form.birthdate": "Туғилган сана",
	"application_form.isSecret": "Мурожаат ошкоралиги",
	"application_form.address": "Манзил",
	"application_form.email": "Электрон почта",
	"application_form.feedback_email": "Электрон почта (ихтиёрий)",
	"application_form.phone": "Телефон",
	"application_form.entrip": "Тадбиркор",
	"application_form.entripHint": "Тадбиркорлик субъекти сифатида мурожаат қилаётган бўлсангиз ушбу катакчани белгиланг",
	"application_form.status": "Мақом",
	"application_form.fileLabel": "Қўшимча файл",
	"application_form.fileHint": "Қўшимча файлни кўрсатинг <br/>(хажми  5мб гача)",
	"application_form.applicationLabel": "Мурожаат матни",
	"application_form.applicationHint": "Мурожаатингиз тезкор равишда ҳал этилишини истасангиз, ҳар бир масала бўйича алоҳида мурожаат йўллашингизни ҳамда мазкур мурожаатни лўнда, оддий ва равон тилда баён этишингизни сўраймиз!",
	"application_form.sendButton": "Жўнатиш",
	"application_form.notAccepted": "Тақиқланган файл",
	"application_form.maxNumberOverflow": "Жами файллар сони 10 тадан ошмаслиги лозим",
	"application_form.uploadFile": "Файлни юкланг",
	"application_form.phoneReal": "Телефон рақами тасдиқланди!",
	"application_form.getCode": "Код олиш",
	"application_form.enterCode": "Текширув кодини киритинг",
	"application_form.resendCode": "Қайта юбориш",
	"application_form.codeSendTo": "Текширув коди ушбу рақамга юборилди",
	"application_form.fileSize": "Файлнинг ҳажми 10 мб дан ва жами файллар сони 10 тадан ошмаслиги лозим",
	"application_form.fileUploaded": "Файл юкланди",
	"application_form.error": "Хато!",
	"application_form.secretInfo": "Мурожаат ва мурожаатчи тўғрисида маълумотларнинг ошкоралиги",
	"application_form.makhalla": "Маҳалла",
	"application_form.man": "Эркак",
	"application_form.woman": "Аёл",
	"application_form.yes": "Ҳа",
	"application_form.no": "Йўқ",
	"application_form.showPhone": "Мурожаат йўллаш учун телефон рақамингизни киритинг.",
	"application_form.unknownError": "Хатолик юз берди!",
	"application_form.applicationSuccess": "Сизнинг мурожаатингиз {title}га муваффақиятли юборилди!",
	"application_form.applicationAlreadySuccess": "Сиз бугун айнан ушбу мазмундаги мурожаатни юбордингиз. Илтимос аввалги юборган мурожаатингиз жавобини кутинг!",
	"application_form.pleaseSave": "Диққат!!! Қуйидаги малумотларни сақлаб олинг",
	"application_form.applicationNo": "Мурожаат рақами",
	"application_form.applicationToken": "Текшириш коди",
	"application_form.authority": "Ташкилот номи",
	"application_form.request_no": "Мурожаат рақами",
	"application_form.note_title": "Шахсингизни тасдиқловчи маълумотларни киритинг",
	"application_form.note_warning": "Сиз томондан киритилган шахсга доир маълумотлар учинчи шахсларга ошкор этилмайди ва тарқатилмайди!",
	"application_form.note_text": "Шахсни тасдиқловчи маълумотларни киритиш қуйидаги афзалликларга эга:",
	"application_form.note_list_item_one": "мурожаат юбориш шаклининг кўплаб қисмлари автоматик равишда тўлдирилади",
	"application_form.note_list_item_two": "киритилган мурожаат номингизда сақланади ва уни исталган пайтда id.egov.uz хизмати орқали тизимга кириб топишингиз мумкин бўлади",
	"application_form.note_list_item_three": "мурожаатни асоссиз равишда кўрмасдан қолдириш ҳолатларининг олди олинади",
	"application_form.preliminary_form_title": "Шахсни тасдиқловчи ҳужжат маълумотлари*:",
	"application_form.passport_series": "Серияси",
	"application_form.passport_number": "Рақами",
	"application_form.passport_helper_text": "*Шахсни тасдиқловчи ҳужжат сифатида фуқаролик паспорти, ID-карта ва хорижга чиқиш паспортидан фойдаланиш мумкин",
	"application_form.dd_mm_yy": "кун | ой | йил",
	"application_form.captcha_label": "Расмдаги рақамни киритинг",
	"application_form.preliminary_form_link": "Бу босқични ўтказиб юбориш",
	"application_form.captcha": "Расмдаги мисолнинг жавобини киритинг",
	"application_form.close": "Орқага",
	"application_form.full_name": "Ф.И.О",
	"application_form.feedback_label": "Маҳаллангиз топилмадими?",
	"application_form.choose_mahalla": "Махаллангизни танланг...",
	"application_form.feedback_title": "Қайта алоқа",
	"application_form.feedback_alert": "Сизнинг хабарингиз муваффақиятли юборилди!",
	"application_form.needed_field": "\"{attribute}\" маълумотини тўлдиринг",
	"application_form.is_agree": "Масулят билан танишиш",
	"application_form.juridical_tin": "ИНН",
	"application_form.get_tin": "Получить данные по ИНН",
	"application_form.check_tin": "Проверка ИНН",
	"application_form.passport": "Паспорт, ID-карта или загранпаспорт гражданина",
	"application_form.birth_certificate": "Свидетельство о рождении",
	"application_form.tin_confirmed": "Действительность ИНН подтверждена",
	"application_form.tin_rejected": "ИНН не действителен",
	"application_form.cert_helper_text": "Укажите серию и номер свидетельства о рождении",
	"apps.appeals.appTitle": "Мурожаат йўллаш турлари",
	"apps.appeals.goToRecept": "Яшаш жойингиз бўйича Ўзбекистон Республикаси Президенти Халқ қабулхонасига ташриф буюринг",
	"apps.appeals.callCenter": "<span>1000</span> ёки <span>0-800-210-00-00</span><br>телефон рақамига қўнғироқ қилинг<br>ва ўз масалангизни оғзаки баён қилинг",
	"apps.appeals.sendAppeal": "Виртуал қабулхонага мурожаат юборинг",
	"apps.Authorities.showAll": "Барча йўналишлар",
	"apps.Authorities.close": "Орқага",
	"apps.Authorities.step": "Бўлим",
	"apps.Authorities.noData": "Маълумот топилмади",
	"apps.Authorities.searchBtn": "Излаш",
	"apps.Authorities.emailShort": "эл. почта",
	"apps.Authorities.phone": "Телефон",
	"apps.Authorities.phoneShort": "тел.",
	"apps.Authorities.website": "Веб-сайт",
	"apps.Authorities.websiteShort": "веб-сайт",
	"apps.Authorities.fax": "Факс",
	"apps.Authorities.faxShort": "факс",
	"apps.Authorities.formLabel": "Мурожаат юбориш",
	"apps.Authorities.appTitle": "Вазирлик ва идора раҳбарларининг фуқароларни<br/> қабул қилиш жадвали ва уларга мурожаат юбориш",
	"apps.Authorities.firstUsellessBtn": "Фуқароларни қабул қилиш жадвали",
	"apps.Authorities.secondUselessBtn": "Давлат органларига мурожаат юбориш",
	"apps.Authorities.opt": "Йўқ",
	"apps.Authorities.formInfo": "Ташкилот виртуал қабулхонасига мурожаат юбориш",
	"apps.Authorities.fio": "Ф.И.О.",
	"apps.Authorities.position": "Лавозим",
	"apps.Authorities.receptDays": "Қабул қилиш графиги",
	"apps.Authorities.orgAdress": "Ташкилот почта манзили",
	"apps.Authorities.phone2": "Ташкилот рақами",
	"apps.Authorities.email2": "Электрон почта манзили",
	"apps.Authorities.days": "Ҳафта кунлари",
	"apps.Authorities.time": "Вақти",
	"apps.Authorities.authFirstTab": "Фуқароларни қабул қилиш<br>жадвали ва манзил",
	"apps.Authorities.authSecondTab": "Функция ва вазифалар",
	"apps.Authorities.authThirdTab": "Мурожаат юбориш",
	"apps.Authorities.functions": "Функциялар",
	"apps.Authorities.tasks": "Вазифалар",
	"apps.Authorities.error": "Хато!",
	"apps.Authorities.printButton": "Чоп этиш",
	"apps.Authorities.unknownError": "Хатолик юз берди!",
	"apps.consulates.appName": "Ўзбекистоннинг чет давлатлардаги консуллик муассасалари",
	"apps.consulates.aLabel": "Ўзбекистоннинг чет давлатлардаги консуллик муассасалари",
	"apps.consulates.bLabel": "Чет давлатлардаги фуқаролар учун мурожаат йўллаш формаси",
	"apps.harassment-message.attentionTitle": "ДИҚҚАТ!",
	"apps.harassment-message.attentionText": "Агар Сиз Виртуал қабулхонага мурожаат қилганингиздан сўнг таъқибга дучор бўлсангиз бу ҳақида дарҳол хабар беринг",
	"apps.harassment-message.attentionBtn": "Таъқиб ҳақида хабар",
	"apps.Qa.showAll": "Барча йўналишлар",
	"apps.Qa.appTitle": "Ўзингизни қизиқтирган саволга жавоб топинг",
	"apps.Qa.close": "Орқага",
	"apps.Qa.step": "Бўлим",
	"apps.Qa.noData": "Маълумот топилмади",
	"apps.Qa.searchBtn": "Излаш",
	"apps.Qa.qaHint": "Агар саволингизга тўлиқ жавоб олмаган бўлсангиз қуйидаги органларга мурожаат қилишингиз мумкин:",
	"apps.Qa.watched": "Кўрилган",
	"apps.Receptions.showAll": "Барча йўналишлар",
	"apps.Receptions.uzbekistan": "Ўзбекистон Республикаси",
	"apps.Receptions.close": "Орқага",
	"apps.Receptions.step": "Бўлим",
	"apps.Receptions.noData": "Маълумот топилмади",
	"apps.Receptions.searchBtn": "Излаш",
	"apps.Receptions.address": "Манзил",
	"apps.Receptions.email": "Электрон почта",
	"apps.Receptions.phone": "Телефон",
	"apps.Receptions.website": "Веб-сайт",
	"apps.Receptions.fax": "Факс",
	"apps.Receptions.appTitle": "Халқ қабулхоналарининг манзиллари",
	"apps.Receptions.recpCount": "Қабулхоналар сони",
	"apps.Receptions.trsPhone": "ишонч телефони",
	"apps.Receptions.contacts": "Контактлар",
	"apps.Receptions.appeal": "Шикоят қилиш",
	"apps.Receptions.more": "Батафсил",
	"apps.Receptions.onMap": "Харитада",
	"apps.step": "Бўлим",
	"apps.mainFormTitle": "Ўзбекистон Республикаси Президенти Виртуал Қабулхонаси",
	"fileSizeValidation": "«{file_name}» файлингиз ҳажми катта. Юкланаётган файлнинг ҳажми 10 мб дан ошмаслиги лозим"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/en.json
// module id = 927
// module chunks = 0